import Faqs from "screens/Faqs";
import Home from "screens/Home";
import Login from "screens/Login";
import ErrorView from "screens/404";
import Layout from "layouts/Layout";
import Lenders from "screens/Lenders";
import Contactus from "screens/ContactUs";
import FinalOffer from "screens/FinalOffer";
import HomeMonitor from "screens/HomeMonitor";
import InititalOffer from "screens/InitialOffer";
import ScrollToTop from "components/ScrollToTop";
import ForgotPassword from "screens/ForgotPassword";
import BorrowerTracker from "screens/BorrowerTracker";
import ValidateAccount from "screens/ValidateAccount";
import LayoutWithContexts from "layouts/LayoutWithContexts";
import TypeOfCreditLine from "screens/TypeOfCreditLine";
import CoborrowerTracker from "screens/CoborrowerTracker";
import ResendValidateCode from "screens/ResendValidateCode";
import BorrowerRegisterForm from "screens/BorrowerRegisterForm";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MainThemeUI } from "context/MaterialUITheme/MainThemeUI";
import CoborrowerRegisterForm from "screens/CoborrowerRegisterForm";
import { UserCustomerContextProvider } from "context/UserCustomer/useUserCustomerContext";
import ConfirmNewPassword from "screens/ConfirmNewPassword";

const App = () => {
  return (
    <MainThemeUI>
      <BrowserRouter>
        <UserCustomerContextProvider>
          <ScrollToTop>
            <Routes>
              <Route element={<LayoutWithContexts />}>
                <Route path="/final-offer" element={<FinalOffer />} />
                <Route path="/home-monitor" element={<HomeMonitor />} />
                <Route path="/signup" element={<BorrowerRegisterForm />} />
                <Route path="/initial-offer" element={<InititalOffer />} />
                <Route path="/borrower-tracker" element={<BorrowerTracker />} />
                <Route
                  path="/:sourceId/signup"
                  element={<BorrowerRegisterForm />}
                />
                <Route
                  path="/type-of-credit-line"
                  element={<TypeOfCreditLine />}
                />
                <Route
                  path="/coborrower-tracker"
                  element={<CoborrowerTracker />}
                />
                <Route
                  path="/coborrower-signup"
                  element={<CoborrowerRegisterForm />}
                />
                <Route
                  path="/:brokerName/:loName/signup"
                  element={<BorrowerRegisterForm />}
                />
              </Route>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="*" element={<ErrorView />} />
                <Route path="/login" element={<Login />} />
                <Route path="/lenders" element={<Lenders />} />
                <Route path="/contactus" element={<Contactus />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route
                  path="/confirm-new-password"
                  element={<ConfirmNewPassword />}
                />
                <Route
                  path="/resend-validate-code"
                  element={<ResendValidateCode />}
                />
                <Route
                  path="/validate-account/:email"
                  element={<ValidateAccount />}
                />
              </Route>
            </Routes>
          </ScrollToTop>
        </UserCustomerContextProvider>
      </BrowserRouter>
    </MainThemeUI>
  );
};

export default App;
